import { getHttpClient } from '../core/httpClient';
import type { ContactFormRequest, ContactFormResponse } from '../types';

export class ContactService {
  async submit(contact: ContactFormRequest): Promise<ContactFormResponse> {
    const client = getHttpClient();
    return client.post<ContactFormResponse>('/public/contact', contact);
  }
}

export const contactService = new ContactService();

